import { IUnitShift } from '@/models';
import { formatPersonName } from '@/utils/masterName';

export const searchByResources = (
  unitShift?: IUnitShift,
  _searchText?: string,
) => {
  if (!unitShift) {
    return false;
  }
  if (!_searchText) {
    return true;
  }

  const { users, vehicles, equipments } = unitShift;
  // Haystack carries BOTH name orders: grids display 'Last First' but legacy
  // muscle memory (and old records) type 'First Last'. The badge number
  // follows EACH variant so a search spanning the name→badge boundary
  // ("smith 4471") keeps matching in either order.
  const hasMatchedUser = users?.find((user) => {
    const badge = user.profile?.employmentInformation?.badgeNumber || '';
    const legacyName = [user.firstName, user.lastName]
      .filter(Boolean)
      .join(' ');
    const haystack = [legacyName, badge, formatPersonName(user), badge]
      .filter(Boolean)
      .join(' ');
    return haystack.toLowerCase().includes(_searchText.toLowerCase());
  });
  if (hasMatchedUser) {
    return true;
  }

  const hasMatchedVehicle = vehicles?.find(({ name }) =>
    name?.toLowerCase().includes(_searchText.toLowerCase()),
  );
  if (hasMatchedVehicle) {
    return true;
  }

  return !!equipments?.find(({ name }) =>
    name?.toLowerCase().includes(_searchText.toLowerCase()),
  );
};
